import React, { Fragment, useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogTitle,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { connect } from "react-redux";

const StandardCopyPopup = (props: any) => {
  const [domainId, setDomainId] = useState<number>();

  async function copy(linkingType: string) {
    const service = await import("../../../api/standard.service");
    const module = await import("react-toastify");
    service
      .copyToDomain({
        standardIds: props.standardIds,
        userId: props.profile?.userId,
        domainId: domainId,
        linkingType: linkingType,
      })
      .then((d) => {
        module.toast.success("Standard copied successfully");
        props.showPopUp(false);
      })
      .catch((e) => {
        module.toast.error(
          "Error occured while coping standard. Please verify domain Id."
        );
      });
  }
  return (
    <div>
      <Transition.Root show={true} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0"
          onClose={() => {
            props.showPopUp(false);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:pt-6 w-4/3 h-22">
                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4"></div>
                <div className="sm:flex sm:items-start">
                  <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
                    <DialogTitle
                      as="h3"
                      className="text-sm text-gray-700 sm:ml-4"
                    >
                      Copy Standard
                    </DialogTitle>
                    <p></p>
                    <div className="mt-2">
                      <div className="grid grid-cols-1 divide-y divide-gray-300 border border-gray-300 rounded-lg ">
                        <div className=" bg-gray-100 h-22 px-4 grid grid-cols-12 gap-6">
                          <div className="col-span-12">
                            <span className="mr-2">Copy Standard: </span>
                            {props.standardIds.map((s, index) => {
                              return (
                                <>
                                  <span key={s} className="mr-2">
                                    {index !== 0 && <span>,</span>}
                                    {s}
                                  </span>
                                </>
                              );
                            })}
                          </div>
                          <div className="col-span-12 mb-3">
                            <label>Domain Id</label>
                            <input
                              type="number"
                              value={domainId}
                              onChange={(e) => {
                                setDomainId(parseInt(e.target.value));
                              }}
                              className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse mr-4">
                  <button
                    type="submit"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => {
                      copy("Copy");
                    }}
                  >
                    Copy
                  </button>
                  <button
                    type="submit"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => {
                      copy("OneWay");
                    }}
                  >
                    Copy and 1-way linking
                  </button>
                  <button
                    type="submit"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-color text-base font-medium text-white hover:bg-primary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => {
                      copy("TwoWay");
                    }}
                  >
                    Copy and 2-way linking
                  </button>
                  <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:mt-0 sm:w-auto sm:text-sm"
                    onClick={() => {
                      props.showPopUp(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(StandardCopyPopup);
